import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import theme from 'App.theme';
import PageSpinner from 'components/PageSpinner/PageSpinner';
import { FC } from 'react';

type Props = {
  message?: string;
  color?: string;
  clickThrough?: boolean;
  size?: number;
  nonBlocking?: boolean;
};

export const Loading: FC<Props> = ({
  message,
  color = theme.colors.active,
  clickThrough = false,
  size = 40,
  nonBlocking = false,
}) => {
  return nonBlocking ? (
    <PageSpinner color={color} />
  ) : (
    <div
      style={{
        pointerEvents: clickThrough ? 'none' : 'auto',
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        zIndex: theme.layers.top,
      }}
    >
      <CircularProgress size={size} sx={{ color, pointerEvents: 'auto' }} />
      {message && <Box mt={2}>{message}</Box>}
    </div>
  );
};
